import { render } from "./emulatorView.vue?vue&type=template&id=3aaedc97&scoped=true"
import script from "./emulatorView.vue?vue&type=script&lang=js"
export * from "./emulatorView.vue?vue&type=script&lang=js"

import "./emulatorView.vue?vue&type=style&index=0&id=3aaedc97&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aaedc97"]])

export default __exports__